// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.parameter_value_source_enum */
var ParameterValueSourceEnum;
(function (ParameterValueSourceEnum) {
    ParameterValueSourceEnum["authored"] = "authored";
    ParameterValueSourceEnum["prompted"] = "prompted";
    ParameterValueSourceEnum["measured"] = "measured";
})(ParameterValueSourceEnum || (ParameterValueSourceEnum = {}));
;
export default ParameterValueSourceEnum;
/** Zod schema for parameter_value_source_enum */
export const parameterValueSourceEnum = z.nativeEnum(ParameterValueSourceEnum);
//# sourceMappingURL=ParameterValueSourceEnum.js.map